import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';

const ImagineLetter = () => {
  return (
    <SalesLetterWrapper alt={true}>
      <div className="text-center space-y-12 py-12">
        <h2 className="text-4xl md:text-6xl font-display font-black text-brand-dark leading-tight">
          Imagine How Different <br/> Retirement Could Feel…
        </h2>

        <div className="space-y-8 text-2xl md:text-3xl font-light leading-relaxed">
          <p>Imagine waking up knowing: <br/> <span className="text-brand-gold font-bold">you have more financial breathing room, you have flexible income options, and you’re no longer relying on only one source of retirement income.</span></p>
          
          <div className="h-px w-24 bg-brand-gold/30 mx-auto"></div>
          
          <p className="italic">Imagine: feeling calmer financially, travelling with more confidence, saying “yes” to more experiences, and feeling more flexible and independent again.</p>

          <p className="text-3xl md:text-4xl font-display font-black text-brand-dark pt-6">
            That’s what this program is really about.
          </p>
          
          <p className="text-xl md:text-2xl text-text-secondary">
            Not “getting rich.” Not becoming an internet entrepreneur. <br/>
            But creating: <span className="text-brand-dark font-black">more freedom, flexibility, and peace of mind.</span>
          </p>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default ImagineLetter;